import { useState } from "react";
import { Menu, X, Landmark } from "lucide-react";
import { Button } from "@/components/ui/button";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Calculator", href: "#calculator" },
  { label: "About", href: "#about" },
  { label: "Stories", href: "#testimonials" },
  { label: "FAQ", href: "#faq" },
  { label: "Visit Us", href: "#visit" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-40 bg-bone/95 backdrop-blur border-b border-border">
      <nav className="max-w-7xl mx-auto flex items-center justify-between px-6 lg:px-12 h-16 lg:h-20">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2">
          <Landmark className="h-6 w-6 text-bronze" />
          <span className="font-serif text-2xl font-medium tracking-tight text-forest">
            Rajkiran <span className="text-bronze">Wealth</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(" ", "-")}`}
              className="text-sm font-medium tracking-wide text-muted-foreground transition-colors hover:text-forest"
            >
              {l.label}
            </a>
          ))}
          <Button
            asChild
            data-testid="nav-callback-btn"
            className="bg-forest text-bone hover:bg-forest-light rounded-full px-6"
          >
            <a href="#contact">Get a Call Back</a>
          </Button>
        </div>

        <button
          data-testid="nav-mobile-menu-btn"
          className="md:hidden text-forest"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden border-t border-border bg-bone px-6 py-4 space-y-3">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-mobile-link-${l.label.toLowerCase().replace(" ", "-")}`}
              onClick={() => setOpen(false)}
              className="block text-sm font-medium text-muted-foreground"
            >
              {l.label}
            </a>
          ))}
          <Button asChild className="w-full bg-forest text-bone rounded-full">
            <a href="#contact" data-testid="nav-mobile-callback-btn" onClick={() => setOpen(false)}>
              Get a Call Back
            </a>
          </Button>
        </div>
      )}
    </header>
  );
};
